module.exports = __webpack_public_path__ + "static/sahuagin-8dfdcb0d270fa5f3e41c50a628304bec.jpeg";